import React from 'react';
import { useResponsive } from '../../hooks/use_responsive';
import { SpanLink } from '../span_link/span_link';
import { ReloadOutlined } from '@ant-design/icons';
import styles from './mobile_video_livestream_reload.less';

interface MobileVideoReloadProps {
  livestream: boolean;
}
export const MobileVideoLiveStreamReload = (props: MobileVideoReloadProps) => {
  const { livestream } = props;
  const { isMobile } = useResponsive();
  return (
    <div>
      {isMobile && livestream && (
        <>
          <div className={styles.reloadStream}>
            <SpanLink
              onClick={() => {
                window.location.reload();
              }}
            >
              <ReloadOutlined />
              Reload Livestream
            </SpanLink>
          </div>
        </>
      )}
    </div>
  );
};
